import { render, staticRenderFns } from "./ChangeOfNameApproval.vue?vue&type=template&id=557e7672&scoped=true"
import script from "./ChangeOfNameApproval.vue?vue&type=script&lang=js"
export * from "./ChangeOfNameApproval.vue?vue&type=script&lang=js"
import style0 from "./ChangeOfNameApproval.vue?vue&type=style&index=0&id=557e7672&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557e7672",
  null
  
)

export default component.exports